<template>
  <b-modal
    id="option-config"
    ref="option-config"
    hide-footer
    no-close-on-backdrop
    size="xl"
  >
    <div class="row">
      <div class="col-md-8 col-12 mt-3">
        <label>Nombre de la opción</label>
        <input
          class="form-control"
          v-model="option.descripcion"
          maxlength="250"
        >
        <small class="form-text text-muted">Nombre para identificar la opción</small>
      </div>
      <div class="col-md-8 col-12 mt-3">
        <label>Valor de la opción</label>
        <input
          class="form-control"
          v-model="option.valor"
          maxlength="250"
        >
        <small class="form-text text-muted">Valor asignado a la opción</small>
      </div>
      <div class="col-md-6 col-12 mt-3">
        <label>Orden de la opción</label>
        <input
          class="form-control"
          v-model="option.orden"
          type="number"
        >
        <small class="form-text text-muted">Orden de la opción</small>
      </div>
      <div
        class="col-md-6 col-12 mt-3"
        v-if="checkIfIsSuperAdmin"
      >
        <label>Nivel de la opción</label>
        <select
          class="form-control"
          v-model="option.nivel"
        >
          <option
            value="0"
            selected
          >
            Global
          </option>
          <option value="10">
            Empresa
          </option>
        </select>
        <small class="form-text text-muted">
          Nivel de visualización del tipo de opciones (grupo)
        </small>
      </div>
      <div class="col-md-12 col-12 mb-2">
        Valor extra de la opción
        <vue-json-editor
          v-model="extra"
          mode="code"
          :modes="['code']"
          :show-btns="false"
          :exapndedOnStart="true"
        />
      </div>
    </div>
    <div>
      <vs-button
        class="action"
        color="primary"
        type="border"
        icon="save"
        @click="saveOption()"
        v-if="!isSavingOption"
      >
        Guardar
      </vs-button>
      <b-spinner
        v-else
        key="primary"
        class="mr-1"
        variant="primary"
      />
    </div>
  </b-modal>
</template>

<script>

import vueJsonEditor from 'vue-json-editor';
import { mapGetters } from 'vuex';

import { ioSaveOption } from '@/febos/servicios/api/herramientas.api';
import { OPTION_LEVELS } from '@/febos/global/empresas/componentes/options/OptionConfigurationsMixin';

export default {
  name: 'OptionEditionModal',
  components: {
    vueJsonEditor
  },
  data() {
    return {
      isSavingOption: false,
      option: {},
      extra: {}
    };
  },
  computed: {
    ...mapGetters('Usuario', ['hasPermission']),
    checkIfIsSuperAdmin() {
      return this.hasPermission('FEB99');
    },
  },
  methods: {
    async saveOption() {
      const optionToSave = {
        ...this.option,
        extra: JSON.stringify(this.extra)
      };
      const param = {
        global: +optionToSave.nivel === OPTION_LEVELS.GLOBAL ? 'si' : 'no',
        id: optionToSave.opcionId
      };
      this.isSavingOption = true;
      try {
        const response = await ioSaveOption(param, optionToSave);
        const { opcion: savedOption } = response.data;
        this.$emit('saved', savedOption);
        this.isSavingOption = false;
      } catch (e) {
        console.error(e);
        this.isSavingOption = false;
      }
    },
    setOption(option) {
      this.option = option;
      this.extra = this.option.extra;
    },
    show() {
      this.$refs['option-config'].show();
    },
    hide() {
      this.$refs['option-config'].hide();
    }
  },
  props: {
    valueTypeConfig: {
      type: String,
      required: false,
      default: 'text'
    },
    extraTypeRender: {
      type: String,
      required: false,
      default: 'json'
    }
  }
};
</script>

<style>
.jsoneditor-poweredBy {
  display: none;
}
</style>
